import React from 'react';

import { Box } from '@mui/material';

import useIsAiTaskEnabled from 'src/hooks/useIsAiTaskEnabled';

import AiTimeline from 'src/views-new/AiTimeline';

type Props = {
  taskId: string;
  orgId: string;
  actorEmployeeId: string;
  applicationId: string;
};

const AiSchedulingSidepanel: React.FC<Props> = ({ taskId, orgId, actorEmployeeId, applicationId }) => {
  const aiTaskEnabled = useIsAiTaskEnabled();
  if (!aiTaskEnabled) {
    return null;
  }
  return (
    <Box height="100%" display="flex" flexDirection="column">
      <AiTimeline taskId={taskId} orgId={orgId} actorEmployeeId={actorEmployeeId} applicationId={applicationId} />
    </Box>
  );
};

export default AiSchedulingSidepanel;
